import _ from 'lodash';

/**
 * @param {UUID} eventId
 * @param {Number} price
 * @param {Number} redeemPrice
 * @param {RoomCategoryResource} x
 * @returns {RoomPrice}
 */
export const mapRoomCategoryResourceToRoomPrice = (eventId, price, redeemPrice, x) => {
    return {
        event_id: eventId,
        price,
        redeem_price: redeemPrice,
        room_category_title: x.attributes.title,
        room_category_id: x.id
    };
};

/**
 * @param {RoomPriceResource} x
 * @return {RoomPrice}
 */
export const mapRoomPriceResourceToRoomPrice = x => {
    return {
        price: x.attributes.price,
        event_id: x.attributes.event_id,
        redeem_price: x.attributes.redeem_price,
        room_category_title: _.get(x, 'relationships.room_category.attributes.title', null),
        room_category_id: x.attributes.room_category_id
    };
};
